import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper height100" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-center height100"
}
const _hoisted_3 = { class: "d-flex justify-center my-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_vue_loading, {
            loader: "bars",
            color: "#EE6090",
            size: { width: '50px', height: '50px' }
          })
        ]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          fluid: "",
          class: "height100"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, { class: "pt-5" }, {
              default: _withCtx(() => [
                _cache[8] || (_cache[8] = _createElementVNode("div", null, [
                  _createElementVNode("p", null, "本画面は、園児との初回登録時に表示される画面です。"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "過去にCCSHOMEをご利用いただいたことがある場合、初回登録時とは異なるメールアドレスでログインしようとしています。"),
                  _createElementVNode("p", null, "一度ログアウトをタップし、初回登録時に使用したアカウント、ログイン方法でログインしてください。"),
                  _createElementVNode("br"),
                  _createElementVNode("p", null, "初めて登録される方は、下記に案内状に記載のお子様IDおよびパスワードをご入力ください。"),
                  _createElementVNode("br")
                ], -1)),
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "お子様のID", -1)),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.postFamilyRequest.childCode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postFamilyRequest.childCode) = $event)),
                    outlined: "",
                    dense: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "パスワード", -1)),
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.postFamilyRequest.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.postFamilyRequest.password) = $event)),
                    outlined: "",
                    dense: "",
                    type: "password"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("p", { class: "body-2 blue-grey--text" }, "保護者タイプ", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.postFamilyRequest.parentType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postFamilyRequest.parentType) = $event)),
                    items: _ctx.parentTypes,
                    "item-title": "text",
                    "item-value": "value",
                    outlined: "",
                    dense: ""
                  }, null, 8, ["modelValue", "items"])
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.postFamily,
                    loading: _ctx.btnLoading,
                    color: "primary",
                    block: ""
                  }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode(" 送信 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick", "loading"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_v_btn, {
                    onClick: _ctx.logout,
                    color: "primary",
                    outlined: "",
                    block: ""
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" ログアウト ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}